/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {

    const body = document.querySelector('body');
    window.addEventListener('scroll', () => {

        if (window.scrollY > 155) {
            body.classList.add("is-sticky");
        } else {
            body.classList.remove("is-sticky");
        }
    }, false);

    document.querySelector('.mobile-menu').addEventListener("click", () => {
        document.querySelector('body').classList.toggle("-mobile-menu");
    });

}());
